export enum Selection {
    NoSelection,
    SingleSelection,
    MultiSelection,
}
